enum NodeStatus {
  Completed = "completed",
  Failed = "failed",
  Paused = "paused",
  Cancelled = "cancelled",
}

export { NodeStatus };
